import {
  differenceInMilliseconds,
  endOfMonth,
  getDay,
  setDate,
  setHours,
  setMinutes,
  setSeconds
} from 'date-fns';
import { NUMBER_OF_DAYS_IN_WEEK } from '../../constants';
import type { ScheduleSolversTimeConfigType } from '../../types';

export const lastDayInMonthTime = ({
  startDate,
  endDate,
  userDate
}: ScheduleSolversTimeConfigType) => {
  const viewDuration = differenceInMilliseconds(endDate, startDate);

  const startHour = startDate.getHours();
  const startMinutes = startDate.getMinutes();
  const startSeconds = startDate.getSeconds();

  const endOfMonthDate = endOfMonth(userDate);
  const endOfMonthDateDay = endOfMonthDate.getDate();

  const lastWeekDates = [];
  for (
    let i = endOfMonthDateDay;
    i > endOfMonthDateDay - NUMBER_OF_DAYS_IN_WEEK;
    i--
  ) {
    const date = setDate(endOfMonthDate, i);
    const weekDay = getDay(date);

    lastWeekDates[weekDay] = i;
  }

  const startDateDay = getDay(startDate);

  const dayInThisMonth = lastWeekDates[startDateDay];

  const startDateInThisMonth = setSeconds(
    setMinutes(
      setHours(setDate(userDate, dayInThisMonth), startHour),
      startMinutes
    ),
    startSeconds
  );

  const endDateInThisMonth = new Date(
    startDateInThisMonth.getTime() + viewDuration
  );

  return endDateInThisMonth.getTime() - userDate.getTime();
};
